<template>
  <v-dialog v-model="dialog" max-width="500px" v-if="canPayout" persistent>
    <template v-slot:activator="{ on }">
      <span v-on="disabled || owed <= 0 ? null : on">
        <v-btn icon color="secondary" v-if="type == 'icon'" :disabled="loading">
          <v-icon>mdi-check-circle</v-icon>
        </v-btn>
        <secondary-button :disabled="disabled || owed <= 0" v-else>
          Mark as Paid {{ formatPrice(owed) }}
        </secondary-button>
      </span>
    </template>
    <dialog-card
      title="Confirm"
      @close="dialog = false"
      @submit="submit()"
      :loading="loading"
    >
      <p class="black--text body-medium mb-5">
        <template v-if="type == 'icon'">
          Commission Owed amount {{ formatPrice(owed) }} will be marked as paid
          to {{ getAffiliateName(affiliateId) }}.
        </template>
        <template v-else>
          All the selected Commissions will be marked as paid to
          {{ getAffiliateName(affiliateId) }}. Total {{ formatPrice(owed) }}
        </template>
      </p>
      <select-field
        label="Payment Method"
        :items="paymentMethods"
        rules="required"
        v-model="payment_method"
      ></select-field>
      <div v-if="payment_method === 'Check'">
        <input-field
          rules="required"
          label="Check Number"
          v-model="check_number"
        />
        <div class="mb-4">
          <input
            type="file"
            class="d-none"
            ref="file"
            required
            @change="onFileChange"
            accept="image/*,application/pdf"
          />
          <secondary-button
            width="150px"
            :loading="check_loading"
            :disabled="!check_number"
            @click="$refs.file.click()"
          >
            Upload Check
          </secondary-button>
          <span
            v-if="check_image_url"
            class="ml-3 body-small--medium black--text"
          >
            Check Uploaded
          </span>
          <span
            v-else-if="!check_loading && check_number"
            class="ml-3 body-small--medium red--text"
          >
            No Check Uploaded
          </span>
        </div>
      </div>
      <date-field v-model="paid_at" rules="required" />

      <b class="black--text body-medium">Are you Sure you want to proceed?</b>
      <div class="d-flex" slot="footer">
        <v-spacer></v-spacer>
        <close-button @click="dialog = false" :disabled="loading"
          >No</close-button
        >
        <secondary-button type="submit" :loading="loading" :disabled="loading"
          >Yes</secondary-button
        >
      </div>
    </dialog-card>
  </v-dialog>
</template>

<script>
import {functions, storage} from "@/assets/utils/firebase.utils";
import {httpsCallable} from "firebase/functions";
import CloseButton from "../ui/buttons/CloseButton.vue";
import SecondaryButton from "../ui/buttons/SecondaryButton.vue";
import DialogCard from "../ui/DialogCard.vue";
import SelectField from "../ui/form/SelectField.vue";
import DateField from "../ui/form/DateField.vue";
import InputField from "@/components/ui/form/InputField.vue";
import {getDownloadURL, ref, uploadBytes} from "firebase/storage";

export default {
  components: {
    InputField,
    CloseButton,
    SecondaryButton,
    DialogCard,
    SelectField,
    DateField,
  },
  props: {
    selected: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: () => ({}),
    },
    type: {
      type: String,
      default: "icon",
    },
  },
  data() {
    return {
      loading: false,
      dialog: false,
      payment_method: "",
      check_loading: false,
      check_number: null,
      check_image_url: null,
      paid_at: "",
    };
  },
  computed: {
    affiliateId() {
      return this.$route.params.id;
    },
    owed() {
      return this.selected
        .filter((i) => i.payout == false)
        .reduce((a, i) => parseFloat(i.commission) + a, 0);
    },
  },
  methods: {
    async onFileChange(e) {
      let file = e.target.files[0];
      if (file) {
        this.check_loading = true;
        let contentTypes = [
          "image/png",
          "image/jpg",
          "image/jpeg",
          "application/pdf",
        ];
        if (contentTypes.indexOf(file.type) == -1) {
          this.notifyError("File type not supported.");
          return;
        }
        try {
          const parts = file.name.split(".");
          let ext = parts[parts.length - 1];
          let storageRef = ref(
            storage,
            `affiliates/${this.affiliateId}/checks/${this.check_number}.${ext}`
          );
          await uploadBytes(storageRef, file);
          this.check_image_url = await getDownloadURL(storageRef);
        } catch (error) {
          this.handleError(error);
        }
        this.check_loading = false;
      }
    },
    async submit() {
      const vm = this;
      if (!vm.payment_method) {
        vm.notifyError("Please select a payment method.");
        return;
      }
      if (vm.payment_method === "Check" && !vm.check_image_url) {
        vm.notifyError("Please upload the check image.");
        return;
      }
      try {
        vm.loading = true;
        let payoutAction = httpsCallable(functions, "payoutAction");
        let ids = vm.selected.filter((i) => i.payout == false).map((i) => i.id);
        let data = {
          payment_method: vm.payment_method,
          check_number: vm.check_number,
          check_image_url: vm.check_image_url,
          ids,
          paid_at: vm.paid_at,
          type: "selected-payout",
        };
        await payoutAction(data);
        vm.$emit("onPayout");
        vm.dialog = false;
        vm.loading = false;
        vm.payment_method = "";
        vm.paid_at = "";
      } catch (error) {
        vm.handleError(error);
      }
    },
  },
};
</script>

<style></style>
